// AGENT-A6: Three-state segmented control. Used for the "New / Existing / Both"
// strip and any other tri-value filter (e.g. Quotes / Orders / Both, if needed).
//
// Same visual styling as BooleanToggle — three pills, exactly one always
// selected. Clicking the active pill is a no-op (consumer should always have
// some canonical "both" value if they need a tri state with neutral default).

export interface TriToggleOption<T extends string> {
  value: T;
  label: string;
}

export interface TriToggleProps<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: [TriToggleOption<T>, TriToggleOption<T>, TriToggleOption<T>];
  header?: string;
  ariaLabel?: string;
}

export function TriToggle<T extends string>(
  props: TriToggleProps<T>,
): JSX.Element {
  const { value, onChange, options, header, ariaLabel } = props;
  return (
    <div className="dash-filter-field">
      {header ? <span className="dash-filter-field__header">{header}</span> : null}
      <div
        className="dash-segmented"
        role="group"
        aria-label={ariaLabel ?? header ?? "tri-toggle"}
      >
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`dash-segmented__pill${
              value === opt.value ? " dash-segmented__pill--active" : ""
            }`}
            onClick={() => onChange(opt.value)}
            aria-pressed={value === opt.value}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
